import { useEffect, useRef } from "react";

export const ChatLog = ({ messages, step }) => {
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ block: "end" }); }, [messages.length]);
  return (
    <div role="log" aria-live="polite" aria-relevant="additions" aria-label="Conversation with Trustee" data-testid="chat-log"
      className="flex-1 min-h-[300px] max-h-[62vh] overflow-y-auto flex flex-col gap-4 pr-2 mb-5">
      {messages.map((m) => (
        <div key={m.id} data-testid={`chat-msg-${m.role}`} className={`flex gap-2.5 items-end max-w-[94%] rise ${m.role === "owner" ? "self-end flex-row-reverse" : ""}`}>
          {m.role === "trustee" && <span className="w-5 h-5 rounded-full shrink-0 mb-2" style={{ background: "var(--blue)" }} aria-hidden="true" />}
          <div className={`rounded-xl leading-relaxed text-[15px] ${m.role === "owner" ? "text-white font-medium px-4 py-3" : "px-5 py-3.5"}`}
            style={m.role === "owner" ? { background: "var(--blue)" } : { background: "#fff", borderLeft: "3px solid var(--blue)", border: "1px solid var(--line)", borderLeftWidth: 3, borderLeftColor: "var(--blue)", color: "var(--ink)" }}>
            <span className="sr-only">{m.role === "owner" ? "You: " : "Trustee: "}</span>
            {m.text}
            {m.kind === "faq" && <div className="eyebrow mt-2" style={{ color: "var(--blue)" }}>Answer from our documentation</div>}
          </div>
        </div>
      ))}
      {step?.consent && (
        <div className="ts-card p-5 max-w-[94%] rise" data-testid="consent-card">
          <p className="eyebrow mb-1">Consent · version {step.consent.version}</p>
          <h2 className="text-base md:text-lg font-semibold mb-2" style={{ color: "var(--ink)" }}>{step.consent.title}</h2>
          <p className="text-sm leading-relaxed" style={{ color: "var(--ink-soft)" }}>{step.consent.text}</p>
          <p className="text-xs mt-3" style={{ color: "var(--muted-text)" }}>Nothing is pre-selected. Choosing "Not now" records a decline and you can change it later in Settings.</p>
        </div>
      )}
      <div ref={endRef} />
    </div>
  );
};
